// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import GiftShopRoutes from "./routes/GiftShop";
import BookingRoutes from "./routes/Booking";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const helmetContext = {};

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    // <HelmetProvider context={helmetContext}>
    <Fragment>
      <BookingRoutes />
      <GiftShopRoutes />
    </Fragment>,
    // </HelmetProvider>,
    document
      .getElementById("main-container")
      .appendChild(document.createElement("div"))
  );
});
